import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import { Icon } from 'antd';
import { default as QuotationInitializer } from '../Quotation/initializer';
import TrafficLights from '../PrescoringTool/trafficlights';
import { MAPPED_FIELDS } from '../PrescoringTool/constants'
import messages from './messages';
import './sticky.scss';
import { default as AlertWithMessage } from 'components/Alert/message';

const offerStickyPrice = props => {
  const { price, unit, offer, accessories, selectedColors, services, equippedOptionals, fees } = props;

  function getAlertType(sustainabilityIndex) {
    switch (sustainabilityIndex) {
      case 0: return 'danger';
      case 1: return 'warning';
      case 2: return 'success';
      default: return 'info';
    }
  }

  const hasSustainabilityIndex = () => offer.sustainabilityIndex !== null;

  return (
    <div id="OfferStickyPrice">
      {offer.hasOwnProperty('ref') &&
            offer.hasOwnProperty('monthly_rate') ?
      <>
        <Row className='no-gutters mt-2'>
          {hasSustainabilityIndex() &&
            <div className="position-absolute">
              <TrafficLights
                className={`prescoring-tool-offer-detail`}
                selected={[offer.sustainabilityIndex]}
                enabled={[0,1,2]}
              />
            </div>
          }
          <Col lg={6} md={12}>
            <Row className={'no-gutters'}>
              <Col xs={7} lg={11} md={7} xl={6} className="price-value">
                {parseInt(price) + unit}
                <div className="d-none d-md-none d-lg-block d-xl-none">
                  <strong>{messages.description.defaultMessage}</strong>
                  <br />
                  {messages.price.defaultMessage}
                </div>
              </Col>
              <Col xs={5} xl={6} className="price-description d-xl-block d-lg-none">
                <strong>
                {messages.description.defaultMessage}
                </strong><br/>
                {messages.price.defaultMessage}
              </Col>
            </Row>
          </Col>
          <Col xl={6} lg={6} md={12} className="ant-row-flex ant-row-flex-middle ant-row-flex-center">
            <QuotationInitializer
              offer={offer}
              price={price}
              accessories={accessories}
              selectedColors={selectedColors}
              services={services}
              equippedOptionals={equippedOptionals}
              fees={fees}
            />
          </Col>
        </Row>

        <div className="detail-terms mt-2 mb-2">
          <Icon type='info-circle' className="info-icon-span" />
          Il prezzo del canone mensile è soggetto a variazioni.<br />
          Offerta economica limitata valida fino ad esaurimento scorte.
        </div>
        {offer.sustainabilityIndex >= 0 && offer.sustainabilityMessage && offer.sustainabilityMessage !== '' ?
          <AlertWithMessage
            message={MAPPED_FIELDS.a[offer.sustainabilityMessage] || MAPPED_FIELDS.a['CONGRATULATIONS_THIS_OFFER']}
            type={getAlertType(offer.sustainabilityIndex)}
          />
          : null
        }
      </>
      :
      <>
        <Row className='no-gutters mt-2'>
          <Col md={6} className={'price-value'}>
            {(price === '-' ? price : parseInt(price)) + unit}
          </Col>
          <Col md={6} className={'price-description'}>
            <strong>
            {messages.description.defaultMessage}
            </strong><br/>
            {messages.price.defaultMessage}
          </Col>
        </Row>

        <div className="detail-terms mt-2 mb-2">
          <Icon type='info-circle' className="info-icon-span" />
          Il prezzo del canone mensile è soggetto a variazioni.<br />
          Offerta economica limitata valida fino ad esaurimento scorte.
        </div>
      </>
      }
    </div>
  );
};

offerStickyPrice.defaultProps = {
  unit: '€',
  price: '-',
};

offerStickyPrice.propTypes = {
  price: PropTypes.any,
  unit: PropTypes.string,
};

export default offerStickyPrice;
